import { auth } from './auth'
import {
    setAuthBusy,
    setAuthUser,
} from '../../../reducers/actions/auth'
import { database } from '../database'

/**
 * Fetch logged user and save it into storage
 *
 * @return {Promise}
 */
export const fetchLoggedUser = () => {
    setAuthBusy(true)

    const user = auth().currentUser

    if (!user) {
        setAuthBusy(false)
        return new Promise(resolve => resolve())
    }

    return database('user')
        .doc(user.uid)
        .get()
        .then(doc => {
            if (!doc.exists) {
                return new Promise((resolve, reject) => reject(404))
            }

            setAuthUser({
                ...doc.data(),
                uid: user.uid,
                displayName: user.displayName,
            })

            return new Promise(resolve => resolve(doc.data()))
        })
        .catch(err => err !== 404 ? new Promise((resolve, reject) => reject(500)) : new Promise((resolve, reject) => reject(err)))
        .finally(() => setAuthBusy(false))
}
